import Select from "react-select";
import { ErrorText, InputWrapperDiv, Label } from "../input/input.style";
import { SelectInputComponentStyle } from "./select-input.styles";

const SelectInput = ({ label, error, ...rest }) => {

   const customStyles = {
      menu: (provided, state) => ({
         ...provided,
         backgroundColor: "#fafafa !important",
         fontSize: "1.4rem",
      }),
      option: (provided, state) => (
         {
            ...provided,
            fontSize: '1.4rem',
            backgroundColor: "#fafafa !important",
         })
   }


   return (
      <div>
         <InputWrapperDiv>
            <SelectInputComponentStyle error={!!error}>
               {label && <Label className="select-label">{label}</Label>}
               <Select
                  // styles={customStyles}
                  classNamePrefix="react-select"
                  components={{ IndicatorSeparator: () => null }}
                  {...rest}
               />
               {error && (
                  <ErrorText
                     initial="pageInitial"
                     animate="pageAnimate"
                     exit="pageExit"
                     variants={{
                        pageInitial: {
                           opacity: 1,
                           x: 0,
                           y: -5,
                        },
                        pageAnimate: {
                           opacity: 1,
                           x: 0,
                           y: 0,
                        },
                        pageExit: {
                           opacity: 0,
                        },
                     }}
                  >
                     {error}
                  </ErrorText>
               )}
            </SelectInputComponentStyle>
         </InputWrapperDiv>
      </div >
   );
};

SelectInput.defaultProps = {
   label: "",
};

export { SelectInput };
